"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePhrasesComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const makePhrasesComponent = (i18nInstance, ns, lng) => {
    const Phrases = (props) => ((0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { defaults: props.k, components: props.c, i18n: i18nInstance, values: { ...props.v, formatParams: props.formatParams }, ns: ns, tOptions: { lng } }));
    Phrases.displayName = `Phrases.${ns}`;
    return Phrases;
};
exports.makePhrasesComponent = makePhrasesComponent;
//# sourceMappingURL=makePhrasesComponent.js.map